import * as _ from 'underscore';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';

export interface EMAILBrowser {
	browserName: string;
	browserLogoPath: string;
	clicks: number;
	formattedClicks: string;
	percentValue: number;
	clicks_pc: string;
}

@Component({
	selector: 'app-email-browser-r13',
	templateUrl: './email-browser-r13.component.html',
	styleUrls: ['./email-browser-r13.component.css']
})
export class EmailBrowserR13Component implements OnInit {
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() sectionclass: any;
	@Input() defaultsort: string;
	@Input() sectiontitle: string;
	@Input() columnsconfig: any;

	public key: string;
	public columns: any;
	showLoad = false;
	public hasData: boolean;
	public browserDetails: EMAILBrowser[] = [];
	public reloadSubscription;
	public widgetDataSubscription;
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns;
	public maxValue: number;
	public isR1301: boolean;
	public isR104: boolean;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR1301 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r1301' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r13'
				? true
				: false;
		this.isR104 = this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r104' ? true : false;
		this.columns = JSON.parse(decodeURI(this.columnsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = JSON.parse(decodeURI(this.downloadcsvcolumns));
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processWidgetRequest(this.key, this.columns)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data && response.data.length > 0) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}

	processResponseData(response: any): void {
		this.browserDetails = this.mapEmailBrowserResponseToInterface(response);
	}

	mapEmailBrowserResponseToInterface(responseArray: any[]): EMAILBrowser[] {
		var emailBrowsers: EMAILBrowser[] = [];
		for (const responseObj of responseArray) {
			const emailBrowser: EMAILBrowser = {} as EMAILBrowser;
			emailBrowser.browserName = !UtilityService.isUndefinedOrNull(responseObj.browser_name)
				? responseObj.browser_name
				: responseObj.name;
			emailBrowser.browserLogoPath = responseObj.browser_logo_path;
			emailBrowser.formattedClicks = !UtilityService.isUndefinedOrNull(responseObj.formatted_clicks)
				? responseObj.formatted_clicks
				: 0;
			emailBrowser.clicks = !UtilityService.isUndefinedOrNull(responseObj.clicks) ? parseFloat(responseObj.clicks) : 0;
			emailBrowser.clicks_pc = !UtilityService.isUndefinedOrNull(responseObj.clicks_pc) ? responseObj.clicks_pc : 0.0;
			emailBrowsers.push(emailBrowser);
		}
		const othersBrowser = emailBrowsers.filter((item) => item.browserName.toUpperCase().includes('OTHER'));
		emailBrowsers = emailBrowsers.filter((item) => !item.browserName.toUpperCase().includes('OTHER'));
		emailBrowsers.sort((a, b) => (a.clicks > b.clicks ? -1 : b.clicks > a.clicks ? 1 : 0));
		if (othersBrowser.length > 0) {
			emailBrowsers.push(othersBrowser[0]);
		}
		this.maxValue = Math.max(emailBrowsers[0].clicks, emailBrowsers[emailBrowsers.length - 1].clicks);
		this.calculatePercet(emailBrowsers);
		return emailBrowsers;
	}
	calculatePercet(emailBrowsers) {
		for (const element of emailBrowsers) {
			element.percentValue = this.maxValue != element.clicks ? (element.clicks / this.maxValue) * 100 : 100;
		}
	}
	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}
}
